__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "rs-hunter-tools";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@rappi/mustache-b2b-foundations", "0.0.2", () => (__webpack_require__.e(371).then(() => (() => (__webpack_require__(7371))))));
			register("@rappi/rests-commons-front", "2.44.12", () => (Promise.all([__webpack_require__.e(748), __webpack_require__.e(283), __webpack_require__.e(163), __webpack_require__.e(205), __webpack_require__.e(164), __webpack_require__.e(388)]).then(() => (() => (__webpack_require__(748))))));
			register("@sentry/react", "8.35.0", () => (Promise.all([__webpack_require__.e(455), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(455))))));
			register("axios", "1.7.2", () => (__webpack_require__.e(447).then(() => (() => (__webpack_require__(4447))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(942).then(() => (() => (__webpack_require__(6942))))));
			register("heic-to", "1.0.2", () => (__webpack_require__.e(234).then(() => (() => (__webpack_require__(9234))))));
			register("i18next-browser-languagedetector", "8.0.0", () => (__webpack_require__.e(997).then(() => (() => (__webpack_require__(4997))))));
			register("i18next", "23.11.4", () => (__webpack_require__.e(635).then(() => (() => (__webpack_require__(2635))))));
			register("pdf-lib", "1.17.1", () => (__webpack_require__.e(772).then(() => (() => (__webpack_require__(4772))))));
			register("react-data-table-component", "7.6.2", () => (Promise.all([__webpack_require__.e(757), __webpack_require__.e(283), __webpack_require__.e(163)]).then(() => (() => (__webpack_require__(3757))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(961))))));
			register("react-i18next", "14.1.1", () => (Promise.all([__webpack_require__.e(389), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(2389))))));
			register("react-router-dom", "6.16.0", () => (Promise.all([__webpack_require__.e(588), __webpack_require__.e(976), __webpack_require__.e(283), __webpack_require__.e(98)]).then(() => (() => (__webpack_require__(4976))))));
			register("react-router", "6.16.0", () => (Promise.all([__webpack_require__.e(588), __webpack_require__.e(767), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(7767))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			register("styled-components", "6.1.11", () => (Promise.all([__webpack_require__.e(581), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(7581))))));
			register("swr", "2.2.5", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(283)]).then(() => (() => (__webpack_require__(2648))))));
			initExternal(9249);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};